import React, { Component } from 'react';
import IconWithText from '../icon-with-text/IconWithText.component';
import { ELSButtonIconPosition } from '../../models/button.models';

interface BackToTopButtonState {
  isVisible: boolean;
}

interface BackToTopButtonProps {
  buttonText: string;
}

class BackToTopButton extends Component<BackToTopButtonProps, BackToTopButtonState> {
  constructor(props: BackToTopButtonProps) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const isVisible = window.scrollY > 1000;
    if (this.state.isVisible !== isVisible) {
      this.setState({ isVisible });
    }
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  render() {
    if (!this.state.isVisible) {
      return null;
    }

    return (
      <button
        type="button"
        className="u-els-debuttonize c-els-pill c-ssa-eaq-back-to-top-pill"
        onClick={this.scrollToTop}
        data-testid="ssa-back-to-top-button"
      >
        <IconWithText
          iconName="arrow-up"
          iconPrefix="hmds"
          iconPosition={ELSButtonIconPosition.RIGHT}
        >
          {this.props.buttonText}
        </IconWithText>
      </button>
    );
  }
}

export default BackToTopButton;
